"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _validators = require("./validators");
var rules = {
  firstName: [_validators.required],
  lastName: [_validators.required],
  routingNumber: [_validators.required, _validators.validRoutingNumber],
  accountNumber: [_validators.required, _validators.lastFour, _validators.validBankAccount],
  confirmAccountNumber: [_validators.required, _validators.lastFour, _validators.matchesAccountNumber, _validators.validBankAccount]
};
var _default = rules;
exports["default"] = _default;
